<template>
  <img src="@/assets/empty-state-icon@2x.png" alt="empty" :class="size">
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'is-40'
    }
  }
}
</script>

<style>
  .is-36 {
    width: 36px;
    height: 36px;
  }
  .is-40 {
    width: 40px;
    height: 40px;
  }
  .is-48 {
    width: 48px;
    height: 48px;
  }

</style>



// WEBPACK FOOTER //
// src/components/general/empty-state-icon.vue